import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';
import { Identifiable } from '@mews/std';
import { SearchType } from '@mews-commander/enums';

interface SearchNewEntityDialogBackendState {
    onSuccess: <S extends Identifiable>(data: S) => void;
    searchType: SearchType;
    url: string;
}

// To be able to be used anywhere (e.g. in dispatch)
const searchNewEntityDialogBackendStore = createStore<SearchNewEntityDialogBackendState | null>(() => null);

export const openNewEntityBackendDialog = (state: SearchNewEntityDialogBackendState) => {
    searchNewEntityDialogBackendStore.setState(state);
};

export const closeNewEntityBackendDialog = () => {
    searchNewEntityDialogBackendStore.setState(null);
};

export const useSearchNewEntityDialogBackendStore = <T>(
    selector: (state: SearchNewEntityDialogBackendState | null) => T
) => useStore(searchNewEntityDialogBackendStore, selector);
